export const getPaymentFileName = (payment, type) => {

    const nome = payment.participante.nome
    const data = payment.scheduledDate
        .split('T')[0]
        .split('-').reverse().join('-')

    return `${type === 'receipt' ? 'comprovante' : 'relatorio'}-${nome}-${data}-${payment.id}.pdf`
}